<template>
  <woot-modal :show.sync="show" :on-close="onClose">
    <div class="column content-box">
      <woot-modal-header
        :header-title="$t('INTEGRATION_APPS.QUOTATION_PLAN.ADD.TITLE')"
        :header-content="$t('INTEGRATION_APPS.QUOTATION_PLAN.ADD.DESC')"
      />
      <form class="row" @submit.prevent="addQuotationPlan()">
        <div class="medium-12 columns">
          <label :class="{ error: $v.name.$error }">
            {{ $t('INTEGRATION_APPS.QUOTATION_PLAN.ADD.FORM.NAME.LABEL') }}
            <input
              v-model.trim="name"
              type="text"
              :placeholder="
                $t('INTEGRATION_APPS.QUOTATION_PLAN.ADD.FORM.NAME.PLACEHOLDER')
              "
              @input="$v.name.$touch"
            />
          </label>
        </div>
        <div class="medium-12 columns">
          <label :class="{ error: $v.vehicleType.$error }">
            {{
              $t('INTEGRATION_APPS.QUOTATION_PLAN.ADD.FORM.VEHICLE_TYPE.LABEL')
            }}
            <multiselect
              v-model.trim="vehicleType"
              :options="typeVehicles"
              :searchable="true"
              :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
              label="label"
              track-by="id"
              @input="$v.vehicleType.$touch"
              :hide-selected="false"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.CLICK_TO_SELECT')"
              :deselect-label="$t('FORMS.MULTISELECT.CLICK_TO_REMOVE')"
            />
          </label>
        </div>
        <div class="medium-12 columns">
          <label :class="{ error: $v.description.$error }">
            {{
              $t('INTEGRATION_APPS.QUOTATION_PLAN.ADD.FORM.DESCRIPTION.LABEL')
            }}
          </label>
          <div class="editor-wrap">
            <woot-message-editor
              v-model="description"
              class="message-editor"
              :class="{ editor_warning: $v.description.$error }"
              :enable-variables="true"
              :enable-canned-responses="false"
              :placeholder="
                $t(
                  'INTEGRATION_APPS.QUOTATION_PLAN.ADD.FORM.DESCRIPTION.PLACEHOLDER'
                )
              "
            />
          </div>
        </div>
        <div class="modal-footer">
          <div class="medium-12 columns">
            <woot-submit-button
              :disabled="
                $v.name.$invalid ||
                  $v.vehicleType.$invalid ||
                  $v.description.$invalid ||
                  addPlan.showLoading
              "
              :button-text="
                $t('INTEGRATION_APPS.QUOTATION_PLAN.ADD.FORM.SUBMIT')
              "
              :loading="addPlan.showLoading"
              class="bg-primary"
            />
            <button class="button clear" @click.prevent="onClose">
              {{ $t('INTEGRATION_APPS.QUOTATION_PLAN.ADD.CANCEL_BUTTON_TEXT') }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </woot-modal>
</template>

<script>
import { minLength, required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  components: {
    WootMessageEditor,
  },
  mixins: [alertMixin],
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    integration: {
      type: Object,
      default: () => ({}),
    },
    typeVehicles:  {
      type: Array,
      default: () => ([]),
    }
  },
  data() {
    return {
      name: '',
      vehicleType: '',
      description: '',
      addPlan: {
        showLoading: false,
      },
      show: true,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
    }),
  },
  validations: {
    name: {
      required,
      minLength: minLength(2),
    },
    vehicleType: {
      required,
    },
    description: {
      required,
    },
  },
  methods: {
    resetForm() {
      this.name = '';
      this.vehicleType = '';
      this.description = '';
      this.$v.name.$reset();
      this.$v.vehicleType.$reset();
      this.$v.description.$reset();
    },
    addQuotationPlan() {
      this.addPlan.showLoading = true;

      const payload = {
        nome: this.name,
        tipoVeiculo: this.vehicleType?.id,
        descricao: this.description,
        client_id: this.integration.hooks[0].settings.client_id,
      };

      this.$store
        .dispatch('createPlanQuotation', payload)
        .then(() => {
          this.addPlan.showLoading = false;
          this.showAlert(
            this.$t('INTEGRATION_APPS.QUOTATION_PLAN.ADD.API.SUCCESS_MESSAGE')
          );
          this.resetForm();
          this.onClose();
        })
        .catch(error => {
          this.addPlan.showLoading = false;
          const errorMessage =
            error?.message ||
            this.$t('INTEGRATION_APPS.QUOTATION_PLAN.ADD.API.ERROR_MESSAGE');
          this.showAlert(errorMessage);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.editor-wrap {
  .message-editor {
    border: 1px solid var(--s-200);
  }
}
</style>
